import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import Picker from '../../core/components/Picker'
import {DEFAULT_QUERY, querySubsidiaryStream} from '../actions'
import i18n from '../i18n'

class SubsidiaryPicker extends Component {
    static propTypes = {
        holding: PropTypes.object,
        billingType: PropTypes.string
    }

    componentWillMount() {
        const {dispatch, holding, billingType} = this.props

        dispatch(querySubsidiaryStream({...DEFAULT_QUERY, billingType, holdingUid: holding.uid, range: {offset: 0, limit: 99}}))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.holding != this.props.holding
            || nextProps.billingType != this.props.billingType) {
            const {dispatch, holding, billingType} = nextProps
            dispatch(querySubsidiaryStream({...DEFAULT_QUERY, billingType, holdingUid: holding.uid, range: {offset: 0, limit: 99}}))
        }
    }

    render() {
        const {dispatch, stream, ...others} = this.props

        return (
            <div>
                <Picker
                    source={stream}
                    identify={(p) => p.uid}
                    display={(p) => p.label}
                    {...others} />
            </div>
        )
    }
}

SubsidiaryPicker = connect((state) => ({
    stream: state.company.subsidiary.stream
}))(SubsidiaryPicker)

export default SubsidiaryPicker


// WEBPACK FOOTER //
// ./lib/company/components/SubsidiaryPicker.js